<template>
  <div class="loading-screen">
    <div
      v-bind="$attrs"
      class="background fixed top-0 z-50 flex h-full w-full items-center justify-center p-4 select-none"
    >
      <PCard
        class="flex size-80 items-center justify-center rounded-3xl sm:size-120"
        :hoverable="false"
        color="primary"
      >
        <div class="space-y-8">
          <PeanutsLogo vertical alt="Logo Peanuts" width="384" height="384" fetchpriority="high" />
          <PProgress color="secondary" class="mx-auto max-w-48" />
        </div>
      </PCard>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted } from "vue"
import { storeToRefs } from "pinia"
import { RoleTypes } from "@/enums/role-types"
import { trackPageLoadComplete } from "@/services/application-insights-service"
import { useAuthStore } from "@/store/auth.store"
import PeanutsLogo from "@/components/app/PeanutsLogo.vue"
import PProgress from "@/components/elements/PProgress.vue"
import PCard from "@/components/elements/PCard.vue"
defineOptions({
  inheritAttrs: false
})

const { activeUser } = storeToRefs(useAuthStore())
const loadingStartedAt = performance.now()

onMounted(() => {})

onUnmounted(() => {
  if (!activeUser.value?.knownBusinessEntityContact?.hasRole(RoleTypes.SERVICE_PROVIDER)) {
    trackPageLoadComplete(
      performance.now() - loadingStartedAt,
      activeUser.value?.activeTenant?.name?.trim() || "unknown"
    )
  }
})
</script>

<style scoped></style>
